function Page403() {
  return <div>Access Denied </div>;
}

export default Page403;
